"use client"

import { Toaster as Sonner, toast } from "sonner"
import { cn } from "@/utils/utils"
import { toastStyleDriver } from "@/utils/componentStyle"

type ToasterProps = React.ComponentProps<typeof Sonner>

/**
 * Toast notification system using Sonner
 * Add <Toaster /> to your root layout (e.g., Scaffold) to enable toast notifications
 */
function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      className={cn(toastStyleDriver.toaster)}
      toastOptions={{
        classNames: {
          toast: toastStyleDriver.toast,
          title: toastStyleDriver.toastTitle,
          description: toastStyleDriver.toastDescription,
          actionButton: toastStyleDriver.toastActionButton,
          cancelButton: toastStyleDriver.toastCancelButton,
          closeButton: toastStyleDriver.toastCloseButton,
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
